import { Container, styled } from '@teko/ui';
import React, { useRef } from 'react';
import { Box, Flex } from 'reflexbox';
import { DiscoveryBlock } from 'types';
import { DiscoveryItem } from '@teko/discovery';
import { filterBlockItems } from 'helpers';

interface NavigationBarBlockProps {
  block: DiscoveryBlock;
  blockList: DiscoveryBlock[];
}

interface WrapperProps {
  backgroundColor?: string;
  backgroundImage?: string;
}

const Wrapper = styled.div(
  ({ backgroundColor, backgroundImage }: WrapperProps) => `
  background-color: ${backgroundColor ? `${backgroundColor}` : '#fff'};
  background-image: ${backgroundImage ? `url(${backgroundImage})` : 'unset'};
  position: sticky;
  top: 72px;
  z-index: 1020;
`,
);

const StyledBlockTitle = styled.div<{
  backgroundColor?: string;
  backgroundImage?: string;
}>(
  ({ backgroundColor, backgroundImage }) => `
    font-size: 13px;
    font-weight: 500;
    text-transform: uppercase;
    color: ${
      (backgroundColor && backgroundColor !== '#ffffff') || !!backgroundImage
        ? '#ffffff'
        : 'inherit'
    };
`,
);

const StyledBox = styled(Box)`
  &:hover {
    cursor: pointer;
  }
`;

export const NavigationBarBlock: React.FC<NavigationBarBlockProps> = ({
  block,
  blockList,
}: NavigationBarBlockProps) => {
  const blockItems = block.content.items.filter((item) =>
    filterBlockItems(item, blockList),
  );

  const currentBlockRef = useRef<HTMLDivElement>(null);

  const onClickScroll = (item: DiscoveryItem) => {
    const element = document.getElementById(item.url);
    if (element && currentBlockRef) {
      const mainNavBar = document.getElementById('mainNavigationBar');
      const mainNavBarHeight = mainNavBar.getBoundingClientRect().height;
      const currentBlockHeight =
        currentBlockRef.current?.getBoundingClientRect().height;
      const y =
        element.getBoundingClientRect().top +
        window.pageYOffset -
        (mainNavBarHeight + currentBlockHeight);
      window.scrollTo({ top: y, behavior: 'smooth' });
    }
  };

  return (
    <Wrapper
      ref={currentBlockRef}
      backgroundImage={block.backgroundImageUrl}
      backgroundColor={block.backgroundColor}
    >
      {blockItems?.length > 0 && (
        <Container>
          <Flex>
            {blockItems.map((item) => {
              return (
                <React.Fragment key={item.id}>
                  <StyledBox
                    px={3}
                    height={40}
                    display="flex"
                    alignItems="center"
                    onClick={() => onClickScroll(item)}
                  >
                    <StyledBlockTitle
                      backgroundColor={block.backgroundColor}
                      backgroundImage={block.backgroundImageUrl}
                    >
                      {item.label}
                    </StyledBlockTitle>
                  </StyledBox>
                </React.Fragment>
              );
            })}
          </Flex>
        </Container>
      )}
    </Wrapper>
  );
};
